import React, { useEffect, useMemo, useState, useRef } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import { FaEye, FaTimes } from "react-icons/fa";
import CommonTable from "../../components/CommonTable/CommonTable";
import { BASE_URL, URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import "./UserDetails.css";
import moment from "moment/moment";
import usePermission from "../../customHook/usePermission";
import StatusModal from "../../components/StatusModal/StatusModal";
import axios from "axios";
import DateRange from "../../components/DateRange/DateRange";
import { verified_user } from "../../assets/img/imgIndex";

const Users = () => {
  const arr = [
    { id: 1, name: "Users" },
    { id: 2, name: "Verification" },
    { id: 3, name: "Verified" },
    { id: 4, name: "Rejected" },
  ];

  const location = useLocation();
  const [users, setUsers] = useState([]);
  const [tab, setTab] = useState(location?.state?.tab || 1);
  const [page, setPage] = useState(location?.state?.page || 1);
  const [searchText, setSearchText] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState(null);
  const [address, setAddress] = useState("");
  const [popup, setPopup] = useState(false);
  const navigate = useNavigate();
  const permission = usePermission();
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  const pageRef = useRef(page);
  const tabRef = useRef(location?.state?.tab || 1);

  // keep pageRef in sync with the latest page
  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  // clear state after using it (run only once when component mounts)
  useEffect(() => {
    if (location?.state?.page || location?.state?.tab) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);
  console.log("pageRef.current", pageRef.current);

  const handleView = async (row) => {
    console.log("ROW DATA:", row);

    if (row?.id) {
      navigate("/users-view", {
        state: { id: row?.id, page: pageRef.current },
      });
    }
  };

  const handleVerificationView = (row) => {
    if (row?.id) {
      navigate("/user-verification", {
        state: { id: row.id, page: pageRef.current, tab: tabRef.current },
      });
    }
  };

  const handleSelect = (i) => {
    setPage(1);
    pageRef.current = 1;
    setTab(i.id);
    tabRef.current = i?.id;
  };

  const handleStatusView = async (row) => {
    if (row?.id) {
      const res = await get(`${URLS.USERADDRESS}${row?.id}/`);
      console.log("resadders", res);
      if (res?.status === "success") {
        setAddress(res);
        setPopup(true);
      }
    }
  };

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "sno",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return (
            <span className="sno">
              {String((row?.index || 0) + 1 + (page - 1) * 10).padStart(2, "0")}
            </span>
          );
        },
      },
      {
        Header: "User Name",
        accessor: "name",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "User Type",
        accessor: "user_type",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Mobile Number",
        accessor: "mob_no",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Registration Date",
        accessor: "created_at",
        width: "70%",
        Cell: ({ value }) => {
          return (
            <p className="mb-0">
              {value ? moment(value).format("DD-MM-YYYY") : "N/A"}
            </p>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        width: "70%",
        Cell: ({ value, row }) => {
          return (
            <>
              {permission?.includes("CAN-STATUS-USERS") && (
                <p
                  // onClick={() => handleStatusChange(row?.original)}
                  className="mb-0"
                  style={{
                    color: value === "Active" ? "green" : "red",
                    border:
                      value === "Active" ? "1px solid green" : "1px solid red",
                    fontWeight: 500,
                    padding: "5px 10px",
                    borderRadius: "5px",
                    textAlign: "center",
                    width: "120px",
                    cursor: "default",
                  }}
                >
                  {value === "User Deleted" ? "De Active" : value || "Unknown"}
                </p>
              )}
            </>
          );
        },
      },
      {
        Header: "Verification Status",
        accessor: "verified_status_name",
        width: "70%",
        Cell: ({ value, row }) => {
          const isVerified =
            row?.original?.verified_status === 2 || value === "Accepted";

          if (isVerified) {
            return (
              <p
                className="mb-0"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 6,
                  color: "#7a52ab",
                  // border: "1px solid #7a52ab",
                  fontWeight: 500,
                  padding: "5px 10px",
                  borderRadius: "5px",
                  // width: "150px",
                }}
              >
                <img src={verified_user} width={18} height={18} alt="" />
                Verified
              </p>
            );
          }

          return <p className="mb-0">Not Verified</p>;
        },
      },
    ];

    let textaction = {
      Header: "Last Demand At",
      accessor: "textaction",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        return (
          <>
            {permission?.includes("CAN-VIEW-USERS") && (
              <button
                className="action-btn"
                onClick={() => handleStatusView(row?.original)}
              >
                <FaEye />
              </button>
            )}
          </>
        );
      },
    };

    let action = {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        return (
          <>
            {permission?.includes("CAN-VIEW-USERS") && (
              <button
                className="action-btn"
                onClick={() => handleView(row?.original)}
              >
                <FaEye />
              </button>
            )}
          </>
        );
      },
    };

    return [...d, textaction, action];
  }, [page]);

  const verificationColumns = useMemo(() => {
    return [
      {
        Header: "S.No",
        accessor: "sno",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return (
            <span className="sno">
              {String((row?.index || 0) + 1 + (page - 1) * 10).padStart(2, "0")}
            </span>
          );
        },
      },
      {
        Header: "User Name",
        accessor: "name",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Mobile Number",
        accessor: "mob_no",
        width: "70%",
        Cell: ({ value }) => {
          return <p className="mb-0">{value || "N/A"}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "verified_status_name",
        width: "70%",
        Cell: ({ value }) => {
          return (
            <p
              className="mb-0"
              style={{
                color: "#7a52ab",
                border: "1px solid #7a52ab",
                fontWeight: 500,
                padding: "5px 10px",
                borderRadius: "5px",
                textAlign: "center",
                width: "120px",
              }}
            >
              {value || "N/A"}
            </p>
          );
        },
      },
      {
        Header: "Updated Date",
        accessor: "updated_at",
        width: "70%",
        Cell: ({ value }) => {
          return (
            <p className="mb-0">
              {value ? moment(value).format("DD-MM-YYYY") : "N/A"}
            </p>
          );
        },
      },
      {
        Header: "Action",
        accessor: "action",
        disableSortBy: true,
        width: "20%",
        Cell: ({ row }) => {
          return (
            <>
              {permission?.includes("CAN-VIEW-USERS") && (
                <button
                  className="action-btn"
                  onClick={() => handleVerificationView(row?.original)}
                >
                  <FaEye />
                </button>
              )}
            </>
          );
        },
      },
    ];
  }, [page, permission]);

  const handleClearSearch = () => {
    setSearchText("");
    setPage(1);
  };

  const fetchUsers = async () => {
    try {
      let res;
      if (tab === 1) {
        res = await get(
          `${URLS.USERLIST}?page=${page || 1}&search=${searchText || ""}&from_date=${fromDate || ""}&to_date=${toDate || ""}`,
        );
      } else {
        const tabMap = {
          2: "verification",
          3: "verified",
          4: "rejected",
        };
        const params = new URLSearchParams({
          page: String(page || 1),
          tab: tabMap[tab] || "verification",
          search: searchText || "",
        });
        res = await get(`${URLS.USER_VERIFICATIONS}?${params.toString()}`);
      }
      console.log("Users list res:", res);
      if (res?.status === "success") {
        setUsers(res?.data || []);
        setTotalCount(res?.total_count || res?.count || 0);
        setPagination({
          current_page: res?.current_page || 1,
          last_page: res?.total_pages || 1,
        });
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, [page, searchText, fromDate, toDate, tab]);

  const handleDownload = async () => {
    const token = await localStorage.getItem("token");

    try {
      const response = await axios.get(
        `${BASE_URL}admin/users/?search=${searchText || ""}&from_date=${fromDate || ""}&to_date=${toDate || ""}&download=excel`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "Kadugudappa_Users_Report.xlsx");
      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <>
      <PageHeader title="Users" />
      <div className="d-flex gap-5 mb-5">
        {arr.map((i) => {
          return (
            <button
              onClick={() => handleSelect(i)}
              className={
                tab == i.id ? "header-action-btn" : "header-action-white-btn"
              }
              key={i.id}
            >
              {i.name}
            </button>
          );
        })}
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
          flexWrap: "wrap",
          gap: 10,
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
          Total: {totalCount || 0}
        </h2>
        {tab === 1 && (
          <DateRange
            fromDate={fromDate}
            toDate={toDate}
            setFromDate={setFromDate}
            setToDate={setToDate}
          />
        )}
        <div
          style={{ display: "flex", alignItems: "center", gap: 5 }}
          className="search-wrapper"
        >
          {tab === 1 && (
            <button className="export-button" onClick={handleDownload}>
              Export
            </button>
          )}
          <input
            type="text"
            placeholder="Search"
            className="search-input"
            value={searchText || ""}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPage(1);
            }}
          />
          {searchText && (
            <FaTimes
              className="search-clear-icon"
              onClick={handleClearSearch}
            />
          )}
        </div>
      </div>
      <CommonTable
        key={tab}
        columns={tab === 1 ? columns : verificationColumns}
        data={users || []}
        pagecount={pagination}
        setPageno={setPage}
        pageno={page || 1}
      />
      <StatusModal
        isOpen={popup}
        onClose={() => setPopup(false)}
        message={address?.address}
        time={address?.last_click_update}
      />
    </>
  );
};

export default Users;
